import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { useLanguage } from "../i18n/LanguageContext";

const NotFound = () => {
  const { t } = useLanguage();

  return (
    <>
      <NavBar />
      <main className="min-h-screen bg-gray-50 pt-28 pb-16 px-6">
        <div className="container mx-auto max-w-3xl text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {t("notFound.title")}
          </h1>
          <p className="text-gray-700 mb-8">{t("notFound.text")}</p>
          <Link
            to="/"
            className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
          >
            {t("common.backToHome")}
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
